module.exports = __webpack_public_path__ + "img/clipboard-two-papers.c5b2a5fc.svg";